import { MenhirBudgetLogos } from '@/common/integrations/menhir/employee/budgets/budgets.types';
import { IMovement } from '@/common/integrations/menhir/employee/movements/movements.types';
import {
  IBadgeIconType,
  IBenefitType,
  IPocketType,
} from '@/common/types/general';
import { benefitTypeSlugMapping } from '@/common/utils/benefits/benefit-utils';
import { BenefitIcon } from '@/web/components/BenefitIcon/BenefitIcon';
import { getBudgetIcon } from '@/web/containers/Budgets/containers/BudgetsHome/util';
import { budgetTopupTypes } from '@/web/containers/Budgets/util';
import {
  IconMoneyBillTrendUp,
  IconRightLeft,
  IconSack,
  IconShieldPlus,
  themeVars,
} from '@coverflex-tech/hypernova';

interface IProps {
  type: IBadgeIconType;
  subcategory?: IMovement['subcategory'];
  className?: string;
  pocketType?: IPocketType;
  budgetLogo?: MenhirBudgetLogos;
  isDebit?: boolean;
}

const isBenefitType = (type: IBadgeIconType): type is IBenefitType =>
  Object.keys(benefitTypeSlugMapping).includes(type);

export const MovementIcon = ({
  type,
  subcategory,
  className,
  pocketType,
  budgetLogo,
  isDebit,
}: IProps) => {
  let icon = null;

  if (pocketType === 'budget' && subcategory === 'ewa_request') {
    return (
      <IconMoneyBillTrendUp
        color={themeVars.color.semantic.text.accentSecondary10}
        className={className}
      />
    );
  } else if (
    pocketType === 'budget' &&
    !budgetTopupTypes.includes(subcategory)
  ) {
    return budgetLogo
      ? getBudgetIcon({
          type: budgetLogo,
          color: themeVars.color.semantic.text.accentSecondary10,
          className: className,
        })
      : null;
  } else if (isBenefitType(type)) {
    return (
      <BenefitIcon
        benefit={benefitTypeSlugMapping[type]}
        className={className}
      />
    );
  } else {
    switch (type) {
      case 'top_up':
        icon = (
          <IconSack
            color={themeVars.color.semantic.text.systemSuccess}
            className={className}
          />
        );
        break;
      case 'transfer':
        icon = (
          <IconRightLeft
            color={
              isDebit
                ? themeVars.color.semantic.text.accentSecondary10
                : themeVars.color.semantic.text.systemSuccess
            }
            className={className}
          />
        );
        break;
      case 'employee_to_company':
        icon = (
          <IconRightLeft
            color={themeVars.color.semantic.text.accentSecondary10}
            className={className}
          />
        );
        break;
      case 'health':
        icon = (
          <IconShieldPlus
            color={themeVars.color.semantic.text.accentSecondary10}
            className={className}
          />
        );
        break;
    }
  }
  return icon;
};
